import Vue from 'vue'
import Vuex from 'vuex'
import { getDefaults } from '@/utils/importUtil'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: getDefaults(require.context('@/store/modules/', false, /\.js$/))
})



// WEBPACK FOOTER //
// ./src/store/index.js